<template>
  <div class="orderDt">
    <van-nav-bar :title="title" 
      left-arrow
      @click-left="onClickLeft"
      class="topBar"
    />
    <div style="height:45px"></div>
    <!-- 生产检验 -->
    <!-- <van-tabs v-model="activeName" class="bqs" @change="ckActve">
      <van-tab title="待下发" name="已提交待下发"></van-tab>
      <van-tab title="待整改" name="已下发待整改"></van-tab>
      <van-tab title="待验收" name="已整改待验收"></van-tab>
      <van-tab title="已归档" name="已归档"></van-tab>
    </van-tabs> -->
    <!-- v-if="item.yqzt=='延期申请'" -->
    <div class="van-cell setBox noLine gdItem" v-for="(item,index) in yhList" :key="index" @click="goXf(item)" v-if="item.yqzt" >
      <div class="flex1 setBox noLine">
        <div class="flex1">
          <font class="orderNum cptit"><b>{{item.ssbzname}}</b> </font>
          <font class="status">
              <div class="point "></div>
              {{item.yqzt}}
              <van-icon name="arrow" class="rightBtn"/>
          </font>
        </div>
        <div class="flex1">
          等级：{{item.yhdj}}
        </div>
        <div class="flex1">
          提报人：{{item.tbr}}
        </div>
        <div class="flex1">
          检查时间：{{item.jcrq}}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import _URL from "../../lib/url";
  import { Toast, Dialog, RadioGroup, Radio, PullRefresh } from "vant";
  import { getAction, postAction } from "@/api/manage";
  export default {
    name: "index",
    data: function () {
      return {
          activeName: '已提交待下发',
          title: this.$route.query.title,
          yhList:[],
      };
    },
    mounted: function () {
      let that = this;
      //获取巡检列表
      that.getList()
      let active =  localStorage.getItem('active')
      if(!active){
        active = 0
      }
      that.activeName = active;
    },
    methods: {
      goXf(item){
        let that = this
        let showBtn = false;
        if(item.yqzt=="待审核"){
          showBtn = true
        }
        that.$router.push({
          path:'things',
          query:{
            type:'2.5',
            showBtn:showBtn,
            title:'延期审批',
            id:item.id
          }
        });
      },
      getList(){
          // let that = this;
          // let obj = {
          //   roleid:localStorage.getItem('roleid'),
          //   roletype :localStorage.getItem('roletype'),
          //   ssbmid :localStorage.getItem('ssbmid'),
          //   ssbzid :localStorage.getItem('ssbzid'),
          //   userid:localStorage.getItem('uid')
          // };
          // Toast.loading({
          //   message: "数据加载中...",
          //   forbidClick: true,
          //   duration: 0,
          // });
          // getAction(`${_URL.gsYhglzglist}`, obj).then((res) => {
          //   console.log(JSON.stringify(res));
          //   Toast.clear();
          //   that.yhList = res.resultData;
          // });
          let that = this;
          let obj = {
            userid:localStorage.getItem('uid')
          };
          Toast.loading({
            message: "数据加载中...",
            forbidClick: true,
            duration: 0,
          });
          getAction(`${_URL.gsYhglxflist}`, obj).then((res) => {
            console.log(JSON.stringify(res));
            Toast.clear();
            that.yhList = res.resultData;
          });
      },
      ckActve(avtive){
          localStorage.setItem('active',avtive)
      },
      onClickLeft: function() {
        this.$router.go(-1);
      },
    },
  };
</script>
<style lang="less">
  .orderDt{
    .rightBtn{
        font-size:20px;
        position: relative;
        float: right;
        top:2px;
        margin-left:10px
    }
    .cptit{
        font-size:17px;
    }
    .progressd{
        width:90%;
        margin-left:5%;
    }
    .progs{
        position: relative;
        top:11px
    }
    .van-tabs__line{
      background-color: #1773f8;
    }
  }
</style>
  
  